<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin: -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title">
                                <span class="index">
                                    <i class="soap-icon-star circle"></i>
                                </span>
                                {{ titleinfo[getCurrentLocale] }}
                            </h1>
                        </div>
                        <br />

                        <div class="booking-information sdr-box">
                            <h4 v-html="info_h4_1[getCurrentLocale]"></h4><br />
                            <p v-html="info_10[getCurrentLocale]"></p>



                            <br /><p>Update: 13.12.2021</p>
                        </div>
                    </div>
                    <!-- End: -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->

        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Important Informations',
                    de: 'Wichtige Informationen',
                },
                // >>> --------------------------
                info_h4_1 : {
                    en: 'Proof of vaccination, immunity or a negative COVID-19 test are mandatory on all SUNDAIR flights:',
                    de: '3G Nachweis auf SUNDAIR Flügen erforderlich:',
                },
                info_10 : {
                    en: 'Dear passengers,<br /><br />A proof of vaccination or immunity or a negative COVID19 test is required on all departing flights from Germany.<br /><br /><strong>Following proofs must be provided at departure:</strong><br />-Proof of vaccination: Valid is a printed or digital proof of a vaccination series completed more than 14 days ago of a vaccine approved in the EU.<br />-Proof of immunity: The proof of recovery (printed or digital)  must be a PCR/LAMP/TMA test proof that is at least 28 days and maximum six months old.<br />-Test certificates: Antigen, PCR, LAMP and TMA tests conducted at certified COVID19 testing sites are valid. PCR, LAMP, TMA  and Antigen tests may be carried out at the earliest 24 hours before arrival in Germany. <br /><br />This rule applies to passengers six years of age and older.<br /><br /><br />Thank you for your understanding and cooperation.<br />Your SUNDAIR-Team',
                    de: 'Liebe Fluggäste,<br /><br />ab sofort gilt auf allen Flügen ab Deutschland die Nachweispflicht von Impf- oder Immunitätsausweisen oder von negativen COVID19 -Tests.<br /><br /><strong>Folgende Nachweise bei Abflug müssen erbracht werden:</strong><br /><br />-Impfnachweis: Gültig ist ein ausgedruckter  oder digitaler Nachweis einer vor mehr als 14 Tagen abgeschlossenen Impfserie eines in der EU zugelassenen Impfstoffs.<br />-Immunitätsnachweis: Der Genesungsnachweis (ausgedruckt oder digital) muss ein PCR-/LAMP-/TMA-Testnachweis sein, der mindestens 28 Tage und maximal sechs Monate alt ist.<br />-Testnachweis: Gültig sind Antigen-, PCR-, LAMP- und TMA-Tests, die an zertifizierten COVID-19-Teststellen durchgeführt wurden. PCR-, LAMP-, TMA sowie Antigen-Tests dürfen frühestens 24 Stunden vor Ankunft vorgenommen werden.<br /><br />Diese Regelung gilt für Fluggäste ab sechs Jahren.<br /><br /><br />Vielen Dank für Ihre Unterstützung und für das entgegengebrachte Vertrauen.<br />Ihr SUNDAIR-Team',
                },
                // >>> --------------------------
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    a[target='_blank']:after {
        font-family: 'FontAwesome';
        content: ' \f08e';
    }

    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        h1 {
            font-size: 1.6em;
        }
        .booking-information {
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 30px;
            padding-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/infos/info3g/Home.vue